export default {
  BASE_URL: '/admin/cms/catalog',
  api: [
    {
      name: 'list',
      desc: '二级分类',
      method: 'GET',
      path: '/list'
    },
    {
      name: 'checkName',
      desc: '检查分类名称是否重复',
      method: 'GET',
      path: '/checkName'
    },
    {
      name: 'insert',
      desc: '新增分类',
      method: 'POST',
      path: '/add'
    },
    {
      name: 'update',
      desc: '编辑分类',
      method: 'POST',
      path: '/edit'
    },
    {
      name: 'enable',
      desc: '启用/停用分类',
      method: 'PUT',
      path: '/upStatus'
    },
    {
      name: 'delete',
      desc: '删除分类',
      method: 'DELETE',
      path: '/del'
    },
    {
      name: 'sorting',
      desc: '变更排序',
      method: 'PUT',
      path: '/upSort'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/api/cms/catalog.js